import { HttpClient } from '@wix/sdk-types';
import {
  BulkUpdateMainEntityTagsByFilterOptions,
  BulkUpdateMainEntityTagsOptions,
  RunTriggerOptions,
  bulkUpdateMainEntityTags as universalBulkUpdateMainEntityTags,
  bulkUpdateMainEntityTagsByFilter as universalBulkUpdateMainEntityTagsByFilter,
  runTrigger as universalRunTrigger,
} from './automations-v1-automations-custom-trigger-custom-trigger.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/automations' };

export function runTrigger(httpClient: HttpClient): RunTriggerSignature {
  return (options?: RunTriggerOptions) =>
    universalRunTrigger(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface RunTriggerSignature {
  /**
   * Runs the automation associated with the trigger ID that you pass to it.
   */
  (options?: RunTriggerOptions): Promise<void>;
}

/** @internal */
export function bulkUpdateMainEntityTags(
  httpClient: HttpClient
): BulkUpdateMainEntityTagsSignature {
  return (options?: BulkUpdateMainEntityTagsOptions) =>
    universalBulkUpdateMainEntityTags(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateMainEntityTagsSignature {
  /** */
  (options?: BulkUpdateMainEntityTagsOptions): Promise<void>;
}

/** @internal */
export function bulkUpdateMainEntityTagsByFilter(
  httpClient: HttpClient
): BulkUpdateMainEntityTagsByFilterSignature {
  return (options?: BulkUpdateMainEntityTagsByFilterOptions) =>
    universalBulkUpdateMainEntityTagsByFilter(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface BulkUpdateMainEntityTagsByFilterSignature {
  /** */
  (options?: BulkUpdateMainEntityTagsByFilterOptions): Promise<void>;
}

export {
  BulkUpdateMainEntityTagsByFilterOptions,
  BulkUpdateMainEntityTagsByFilterRequest,
  BulkUpdateMainEntityTagsByFilterResponse,
  BulkUpdateMainEntityTagsOptions,
  BulkUpdateMainEntityTagsRequest,
  BulkUpdateMainEntityTagsResponse,
  MainEntity,
  RunTriggerOptions,
  RunTriggerRequest,
  RunTriggerResponse,
  TagList,
  Tags,
} from './automations-v1-automations-custom-trigger-custom-trigger.universal.js';
